
import Tabs from "../tabs";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Grid, Button, Box, Stack, Typography, Checkbox, Avatar, AvatarGroup, IconButton, Tooltip } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SearchIcon from "@mui/icons-material/Search";
import GroupOffOutlinedIcon from "@mui/icons-material/GroupOffOutlined";
import { FieldSelect } from "../../../../components/selections/fieldInputs";
import { QR, QrActionButton } from "../../../qrCode/components/qrUi";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import { getHeadLevelEmployeeThunk, getLevelWiseEmployeesThunk, getUnAssignedEmployeeesThunk, deleteLevelEmployeesThunk, getLeadLevelsThunk } from "../../leadMangementThunk";
import DeleteIcon from '@mui/icons-material/Delete';
import { setResetEmployees } from '../../leadMangementSlice';
import InsertUnAssigningEmployees from "./insertUnAssigningEmployees";
import { getEmployeeThunk } from "../../../employees/employeeThunk";
import { resetLeadManagementState } from "../../leadMangementSlice";
import ListIcon from "@mui/icons-material/List";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

export default function UserManagement() {
    const dispatch = useDispatch();
    const { branchDepartments } = useSelector((state) => state.general);
    const { leadLevels = [], status, status4, error, getHeadLevelEmployees = [], getLevelWiseEmployees = [] } = useSelector(
        (state) => state.leadManagement
    );

    const { getEmployees } = useSelector((state) => state.employees);
    const getLevelWiseEmployees1 = getLevelWiseEmployees.map((item) => ({ value: item.id, label: item.employee_name }));

    const colors = [
        "linear-gradient(135deg, #2563eb, #60a5fa)", // blue
        "linear-gradient(135deg, #7c3aed, #a78bfa)", // purple
        "linear-gradient(135deg, #0891b2, #22d3ee)", // teal
        "linear-gradient(135deg, #d97706, #fbbf24)", // amber
    ];

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    useEffect(() => {
        dispatch(getLeadLevelsThunk());
    }, [dispatch])

    const [state, setState] = useState({
        selectBranchDepartmentId: "",
        selectedLevelId: "",
        selectedHeadLevelEmpId: "",
        errors: {},
        selectActionId: 1,
        selectedEmpDeleteUsers: [],
        selectedEmployeeId: "",
        isSubmit: false,
    });

    const { selectBranchDepartmentId, selectedLevelId, selectedHeadLevelEmpId, selectActionId, selectedEmpDeleteUsers, selectedEmployeeId } = state;

    const handleSingleSelectChange = (name, selectedValue) => {
        setState((prev) => ({
            ...prev,
            [name]: selectedValue,
            errors: { ...prev.errors, [name]: "" },
            isSubmit: name === "selectedEmployeeId" ? true : false,
        }));

        if (name === "selectedLevelId") {
            handleDisplayHeadEmp(selectedValue);
        }
    };

    const handleDisplayHeadEmp = async (value) => {
        dispatch(setResetEmployees());
        setState(prev => ({ ...prev, selectedHeadLevelEmpId: "" }))
        try {
            const result = await dispatch(
                getHeadLevelEmployeeThunk({ credentials: { branch_department_id: +selectBranchDepartmentId, level_id: +value } })
            );

            if (result.meta.requestStatus === "fulfilled") {
                setSnackbar({
                    open: true,
                    message: result.payload.message,
                    severity: "success",
                });

            } else {
                setSnackbar({
                    open: true,
                    message: result.payload,
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };

    const userLevelFields = [
        { id: 1, name: "selectBranchDepartmentId", value: selectBranchDepartmentId, label: "Select Branch Departments", type: "select", options: branchDepartments.map((item) => ({ value: item.id, label: item.branch_department_name })) },
        { id: 2, name: "selectedLevelId", value: selectedLevelId, label: "Select Level", type: "select", options: leadLevels.map((item) => ({ value: item.level_id, label: item.level_name })) },
        {
            id: 3,
            name: "selectedHeadLevelEmpId",
            value: selectedHeadLevelEmpId,
            label: "Select Head Level Emp",
            type: "select",
            options: !!selectedLevelId ? getHeadLevelEmployees.map((item) => ({
                value: item.id,
                label: item.employee_name,
            })) : [],
            disabled: status !== "succeeded",
        }, { id: 4, type: "button" }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validations = [
            { valid: !!selectBranchDepartmentId, message: "Branch Department is required", field: "selectBranchDepartmentId" },
            { valid: !!selectedLevelId, message: "Employee Level is required", field: "selectedLevelId" },
            { valid: !!selectedHeadLevelEmpId, message: "Head Employee is required", field: "selectedHeadLevelEmpId" },
        ];

        for (let rule of validations) {
            if (!rule.valid) {
                setState((prev) => ({
                    ...prev,
                    open: true,
                    message: rule.message,
                    severity: "error",
                    errors: { ...prev.errors, [rule.field]: rule.message },
                }));
                return;
            }
        }

        try {
            const result = await dispatch(
                getLevelWiseEmployeesThunk({ credentials: { branch_department_id: +selectBranchDepartmentId, head_employee_id: +selectedHeadLevelEmpId } })
            );

            await dispatch(getUnAssignedEmployeeesThunk({ credentials: { branch_department_id: +selectBranchDepartmentId } }))

            if (result.meta.requestStatus === "fulfilled") {
                setSnackbar({
                    open: true,
                    message: result.payload.message,
                    severity: "success",
                });
                setState(prev => ({ ...prev, isSubmit: true, selectActionId: 1 }));
                dispatch(getEmployeeThunk({ type: "getEmpData" }));
            } else {
                setSnackbar({
                    open: true,
                    message: result.payload,
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };


    useEffect(() => {
        if (status === "failed")
            setSnackbar({ open: true, message: error, severity: "error" });
    }, [status, error]);


    const handleToggleUser = (userId) => {
        setState((prev) => {
            const isSelected = prev.selectedEmpDeleteUsers.includes(userId);
            return {
                ...prev,
                selectedEmpDeleteUsers: isSelected
                    ? prev.selectedEmpDeleteUsers.filter((id) => id !== userId) // remove if already selected
                    : [...prev.selectedEmpDeleteUsers, userId], // add if not selected
                selectedEmployeeId: "",
            };
        });
    };

    const handleDeleteEmp = async () => {
        let errors = {};

        // Validation: No checkboxes selected
        if (state.selectedEmpDeleteUsers.length === 0) {
            errors.selectedEmpDeleteUsers = "Please select at least one employee to delete";
        }

        // Validation: No dropdown selection
        if (!state.selectedEmployeeId) {
            errors.selectedEmployeeId = "Please select an employee";
        }

        // If validation fails
        if (Object.keys(errors).length > 0) {
            setState((prev) => ({
                ...prev,
                errors,
            }));

            setSnackbar({
                open: true,
                message:
                    errors.selectedEmpDeleteUsers ||
                    errors.selectedEmployeeId ||
                    "Validation failed",
                severity: "error",
            });

            return;
        }

        // ✅ Clear previous errors if validation passes
        setState((prev) => ({
            ...prev,
            errors: {},
        }));

        try {
            const result = await dispatch(
                deleteLevelEmployeesThunk({
                    credentials: {
                        "assinged_to_emp_id": selectedEmployeeId,
                        "deletedEmployees": selectedEmpDeleteUsers,
                        "branch_department_id": selectBranchDepartmentId,
                    }
                })
            );


            if (result.meta.requestStatus === "fulfilled") {
                setSnackbar({
                    open: true,
                    message: result.payload.message,
                    severity: "success",
                });

                handleEmptyState();
                dispatch(resetLeadManagementState());
            } else {
                setSnackbar({
                    open: true,
                    message: result.payload,
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };


    // After employees are inserted: show the List tab for the same selection (fields stay filled)
    // and reload that head's employees + the unassigned list.
    const handleInsertSuccess = (message) => {
        setState(prev => ({ ...prev, selectActionId: 1, selectedEmpDeleteUsers: [], errors: {} }));
        dispatch(getLevelWiseEmployeesThunk({ credentials: { branch_department_id: +selectBranchDepartmentId, head_employee_id: +selectedHeadLevelEmpId } }));
        dispatch(getUnAssignedEmployeeesThunk({ credentials: { branch_department_id: +selectBranchDepartmentId } }));
        if (message) setSnackbar({ open: true, message, severity: "success" });
    };

    const handleEmptyState = () => {
        setState(prev => ({
            ...prev,
            selectBranchDepartmentId: "",
            selectedLevelId: "",
            selectedHeadLevelEmpId: "",
            errors: {},
            selectActionId: 1,
            selectedEmpDeleteUsers: [],
            selectedEmployeeId: "",
            isSubmit: false,
        }))
    }

    // ---------- Look ----------
    const fieldIcons = { 1: <ApartmentIcon />, 2: <LayersOutlinedIcon />, 3: <SupervisorAccountOutlinedIcon /> };
    const actionTabs = [
        { value: 1, label: "List", icon: <ListIcon />, color: QR.blue },
        { value: 2, label: "Insert", icon: <PersonAddIcon />, color: QR.main },
        { value: 3, label: "Delete", icon: <DeleteIcon />, color: "#dc2626" },
    ];

    // One employee card (white, initial avatar, index badge)
    const renderEmployeeCard = (item, index, selectable) => {
        const c = colors[index % colors.length];
        const checked = selectable && state.selectedEmpDeleteUsers.includes(item.value);
        return (
            <Box
                key={index}
                onClick={selectable ? () => handleToggleUser(item.value) : undefined}
                title={selectable ? `Select ${item.label}` : item.label}
                sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    py: 0.75,
                    px: 1,
                    pr: selectable ? 4 : 1,
                    minWidth: 0,
                    borderRadius: 2,
                    cursor: selectable ? "pointer" : "default",
                    bgcolor: checked ? "#fef2f2" : "#fff",
                    border: `1.5px solid ${checked ? "#fca5a5" : QR.border}`,
                    boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
                    transition: "all .15s ease",
                    "&:hover": { borderColor: selectable ? "#fca5a5" : "#cbd5e1", transform: "translateY(-1px)" },
                }}
            >
                <Avatar sx={{ width: 28, height: 28, fontSize: 12.5, fontWeight: 700, color: "#fff", background: c }}>
                    {(item.label || "?").charAt(0).toUpperCase()}
                </Avatar>
                <Box sx={{ minWidth: 0 }}>
                    <Typography noWrap sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a", lineHeight: 1.3 }}>{item.label}</Typography>
                    <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: "#94a3b8", lineHeight: 1.2 }}>#{index + 1}</Typography>
                </Box>
                {selectable && (
                    <Checkbox
                        checked={checked}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => handleToggleUser(item.value)}
                        size="small"
                        sx={{ position: "absolute", right: 2, top: "50%", transform: "translateY(-50%)", p: 0.5, color: "#cbd5e1", "& .MuiSvgIcon-root": { fontSize: 18 }, "&.Mui-checked": { color: "#dc2626" } }}
                    />
                )}
            </Box>
        );
    };

    const cardsGridSx = {
        mt: 2,
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))", lg: "repeat(6, minmax(0, 1fr))" },
        gap: 1,
    };

    const emptyBox = (
        <Box sx={{ mt: 2, py: 4, textAlign: "center", borderRadius: 3, border: "1px dashed #cbd5e1", bgcolor: "#f8fafc" }}>
            <GroupOffOutlinedIcon sx={{ color: "#cbd5e1", fontSize: 32 }} />
            <Typography sx={{ mt: 0.5, fontSize: 13.5, fontWeight: 600, color: "#64748b" }}>No Data Found</Typography>
        </Box>
    );

    return (
        <div>
            <Tabs>
                {/* ---------- Selection ---------- */}
                <Box sx={{ mt: 1.5 }}>
                    <Typography sx={{ mb: 1.5, fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>
                        Choose a team
                        <Typography component="span" sx={{ ml: 1, fontSize: 12, fontWeight: 500, color: "#94a3b8" }}>
                            Branch department → level → head employee
                        </Typography>
                    </Typography>
                    <Grid container spacing={2} alignItems="flex-end">
                        {
                            userLevelFields.map((field) => (
                                <Grid size={{ xs: 12, sm: field.id === 4 ? 12 : 6, md: 3 }} key={field.id}>
                                    {
                                        field.id === 4 ? (
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, "& > .submit-wrap": { flex: { xs: 1, md: "0 0 auto" } }, "& .submit-wrap .MuiButton-root": { width: { xs: "100%", md: "auto" }, height: 42 } }}>
                                                <Box className="submit-wrap">
                                                <QrActionButton
                                                    variant="solid"
                                                    color={QR.blue}
                                                    gradientTo="#3b82f6"
                                                    icon={<SearchIcon sx={{ fontSize: 18 }} />}
                                                    label="Submit"
                                                    loading={status === "loading"}
                                                    loadingLabel="Submitting.."
                                                    onClick={handleSubmit}
                                                />
                                                </Box>
                                                {/* Reset: clear all fields and start again */}
                                                <Tooltip title="Reset all fields" arrow>
                                                    <IconButton
                                                        aria-label="reset all fields"
                                                        onClick={() => {
                                                            dispatch(setResetEmployees());
                                                            handleEmptyState();
                                                        }}
                                                        sx={{
                                                            flexShrink: 0,
                                                            width: 42,
                                                            height: 42,
                                                            borderRadius: 3,
                                                            color: "#475569",
                                                            bgcolor: "#fff",
                                                            border: "1.5px solid #e2e8f0",
                                                            transition: "all .2s ease",
                                                            "&:hover": { color: QR.blue, borderColor: QR.blue, bgcolor: "#eff6ff" },
                                                            "&:hover svg": { transform: "rotate(-180deg)" },
                                                            "& svg": { transition: "transform .35s ease" },
                                                        }}
                                                    >
                                                        <RefreshRoundedIcon sx={{ fontSize: 21 }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        ) : (
                                            <FieldSelect
                                                name={field.name}
                                                label={field.label.replace(/^Select /, "")}
                                                options={field.options}
                                                value={field.value}
                                                onChange={handleSingleSelectChange}
                                                error={!!state.errors[field.name]}
                                                disabled={field.disabled}
                                                icon={fieldIcons[field.id]}
                                                placeholder={field.label}
                                            />
                                        )
                                    }
                                </Grid>
                            ))
                        }
                    </Grid>
                </Box>

                {
                    state.isSubmit && (
                        <Box sx={{ mt: 2.5, pt: 2, borderTop: `1px solid ${QR.border}` }}>
                            {/* ---------- Action tabs ---------- */}
                            <Box sx={{ p: 0.5, display: "inline-flex", gap: 0.5, maxWidth: "100%", overflowX: "auto", borderRadius: 3, bgcolor: "#f1f5f9", border: `1px solid ${QR.border}` }}>
                                {actionTabs.map((item) => {
                                    const active = selectActionId === item.value;
                                    return (
                                        <Button
                                            key={item.value}
                                            startIcon={item.icon}
                                            onClick={() =>
                                                setState((prev) => ({
                                                    ...prev, selectActionId: item.value,
                                                    selectedEmpDeleteUsers: [],
                                                }))
                                            }
                                            sx={{
                                                height: 36,
                                                px: 2,
                                                borderRadius: 2.5,
                                                textTransform: "none",
                                                fontSize: 13.5,
                                                fontWeight: active ? 700 : 600,
                                                color: active ? item.color : "#64748b",
                                                bgcolor: active ? "#fff" : "transparent",
                                                boxShadow: active ? "0 1px 3px rgba(16,24,40,0.12)" : "none",
                                                "& .MuiButton-startIcon svg": { fontSize: 18 },
                                                "&:hover": { bgcolor: active ? "#fff" : "#e9edf2" },
                                            }}
                                        >
                                            {item.label}
                                        </Button>
                                    );
                                })}
                            </Box>

                            {
                                selectActionId === 1 ? (
                                    <>
                                        {getLevelWiseEmployees1.length > 0 ? (
                                            <Box sx={cardsGridSx}>
                                                {getLevelWiseEmployees1.map((item, index) => renderEmployeeCard(item, index, false))}
                                            </Box>
                                        ) : emptyBox}
                                    </>
                                ) : selectActionId === 2 ? (
                                    <Box sx={{ mt: 2, mb: 2 }}>
                                        <InsertUnAssigningEmployees stateData={state} handleEmptyState={handleEmptyState} onInserted={handleInsertSuccess} />
                                    </Box>
                                ) : (
                                    <Box sx={{ mt: 2, mb: 2 }}>
                                        {getLevelWiseEmployees1.length > 0 ? (
                                            <>
                                                <Typography sx={{ fontSize: 12.5, color: "#64748b" }}>
                                                    Select the employees to remove, then choose who takes over their leads.
                                                </Typography>
                                                <Box sx={cardsGridSx}>
                                                    {getLevelWiseEmployees1.map((item, index) => renderEmployeeCard(item, index, true))}
                                                </Box>

                                                {/* ---------- Delete bar: selected → transfer leads to → delete ---------- */}
                                                {(() => {
                                                    const picked = getLevelWiseEmployees1.filter((e) => state.selectedEmpDeleteUsers.includes(e.value));
                                                    const n = picked.length;
                                                    return (
                                                        <Box
                                                            sx={{
                                                                mt: 2,
                                                                p: { xs: 1.5, sm: 2 },
                                                                display: "flex",
                                                                flexWrap: { xs: "wrap", md: "nowrap" },
                                                                alignItems: { xs: "stretch", md: "flex-end" },
                                                                gap: { xs: 1.5, md: 2 },
                                                                borderRadius: 3,
                                                                bgcolor: "#fff",
                                                                border: `1px solid ${QR.border}`,
                                                                borderLeft: `4px solid ${n ? "#dc2626" : "#e2e8f0"}`,
                                                                boxShadow: "0 4px 14px -8px rgba(15,23,42,0.18)",
                                                            }}
                                                        >
                                                            {/* selected employees */}
                                                            <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minWidth: 0, flex: { xs: "1 1 100%", md: "1 1 auto" }, alignSelf: "center" }}>
                                                                {n > 0 ? (
                                                                    <AvatarGroup max={3} sx={{ "& .MuiAvatar-root": { width: 32, height: 32, fontSize: 13, fontWeight: 700, border: "2px solid #fff" } }}>
                                                                        {picked.map((e) => (
                                                                            <Avatar key={e.value} sx={{ background: colors[getLevelWiseEmployees1.indexOf(e) % colors.length] }}>
                                                                                {(e.label || "?").charAt(0).toUpperCase()}
                                                                            </Avatar>
                                                                        ))}
                                                                    </AvatarGroup>
                                                                ) : (
                                                                    <Box sx={{ width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", bgcolor: "#f1f5f9" }}>
                                                                        <PersonOutlineIcon sx={{ fontSize: 18 }} />
                                                                    </Box>
                                                                )}
                                                                <Box sx={{ minWidth: 0 }}>
                                                                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#0f172a" }}>
                                                                        {n} employee{n === 1 ? "" : "s"} selected
                                                                    </Typography>
                                                                    <Typography noWrap title={picked.map((e) => e.label).join(", ")} sx={{ fontSize: 12, color: "#64748b", maxWidth: 320 }}>
                                                                        {n ? picked.map((e) => e.label).join(", ") : "Tick the employees above to remove them"}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>

                                                            {n > 0 && (
                                                                <>
                                                                    {/* arrow */}
                                                                    <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", justifyContent: "center", width: 32, height: 42, color: "#94a3b8", flexShrink: 0 }}>
                                                                        <ArrowForwardRoundedIcon />
                                                                    </Box>
                                                                    {/* transfer leads to */}
                                                                    <Box sx={{ width: { xs: "100%", md: 280 }, flexShrink: 0 }}>
                                                                        <FieldSelect
                                                                            name="selectedEmployeeId"
                                                                            label="Transfer their leads to"
                                                                            options={getEmployees.map((item) => ({
                                                                                value: item.id,
                                                                                label: item.employee_name,
                                                                            })) || []}
                                                                            value={state.selectedEmployeeId}
                                                                            onChange={handleSingleSelectChange}
                                                                            error={!!state.errors.selectedEmployeeId}
                                                                            icon={<PersonOutlineIcon />}
                                                                            placeholder="Select Employee"
                                                                            required
                                                                        />
                                                                    </Box>
                                                                </>
                                                            )}

                                                            {/* delete */}
                                                            <Box sx={{ flexShrink: 0, width: { xs: "100%", md: "auto" }, "& .MuiButton-root": { width: { xs: "100%", md: "auto" }, height: 42 } }}>
                                                                <QrActionButton
                                                                    variant="solid"
                                                                    color="#dc2626"
                                                                    gradientTo="#ef4444"
                                                                    icon={<DeleteIcon sx={{ fontSize: 18 }} />}
                                                                    label="Delete"
                                                                    loading={status4 === "loading"}
                                                                    loadingLabel="Generating..."
                                                                    onClick={handleDeleteEmp}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    );
                                                })()}
                                            </>
                                        ) : emptyBox}
                                    </Box>
                                )
                            }
                        </Box>
                    )
                }
            </Tabs>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </div>
    );
};